import React, { useEffect, useState, useMemo } from 'react'
import { processInt, processStr, valdiatePage } from '../../global'
import { useDispatch, useSelector } from "react-redux";
import { setLoading } from "../../redux/appSlice";
import { getTickets } from "../../services/complaintservice";
import axios from "axios";
import Pagination from '../../components/paginations';
import { getMultipleSubAccountLocations } from '../../services/userservice';
import { useHistory } from 'react-router';

const ComplaintReport = () => {
    const dispatch = useDispatch();
    const { accounts, userInfo, subaccounts } = useSelector(state => state.appData);
    const initData = {
        from: '',
        to: '',
        type: '',
        cn: '',
        orderRefNo: '',
        status: 1,
        Account: [accounts[0]],
        LocationID: [],
        subAccountId: []
    };

    const [data, setData] = useState(initData);
    const [grid, setGrid] = useState([]);
    const [subAccountsLocal, setSubAccountsLocal] = useState([]);
    const [locations, setLocations] = useState([]);
     
    const [page, setPage] = useState(0);
    const [pageLimit, setPageLimit] = useState(50);
    const [sortConfig, setSortConfig] = useState({ key: null, direction: 'ascending' });
    const [originalGrid, setOriginalGrid] = useState([]);
    const history = useHistory();
    
    const searchObjInit = {
        TicketNo: '',
        CN: '',
        RequestNature: '',
        RequestType: '',
        LaunchDate: ''
    };


    const [searchObject, setSearchObj] = useState(searchObjInit);
    const updateSearchData = (key, val) => setSearchObj(prev => { return { ...prev, [key]: val } });

    const gridKeys = [
        {key: 'TicketNo', name: 'Ticket #', searchBox: true, visible: true},
        {key: 'CN', name: 'Consignment #', searchBox: true, visible: true},
        {key: 'RequestNature', name: 'Request Nature', searchBox: true, visible: true},
        {key: 'RequestType', name: 'Request Type', searchBox: true, visible: true},
        {key: 'Description', name: 'Description', searchBox: false, visible: true},
        {key: 'Status', name: 'Request Status', searchBox: false, visible: true},
        {key: 'LaunchBy', name: 'Launch By', searchBox: false, visible: true},
        {key: 'LaunchDate', name: 'Launch Date', searchBox: true, visible: true}
    ]
    
    const requestSort = (key) => {
        let direction = 'ascending';
        if (sortConfig.key === key && sortConfig.direction === 'ascending') {
          direction = 'descending';
        }
        setSortConfig({ key, direction });
    };

    let filterData = useMemo(() => {
        return grid.filter((item, index) => {
            return (index >= page * pageLimit) & (index < (page + 1) * pageLimit);
        })
    }, [page, grid, pageLimit, grid.length]);

    const sortedArray = [...filterData].sort((a, b) => {
        if (a[sortConfig.key] < b[sortConfig.key]) {
          return sortConfig.direction === 'ascending' ? -1 : 1;
        }
        if (a[sortConfig.key] > b[sortConfig.key]) {
          return sortConfig.direction === 'ascending' ? 1 : -1;
        }
        return 0;
      });


    const updateData = (key, val) => setData(prev => { return { ...prev, [key]: val } })

    const getdata = async (data, source) => {

        dispatch(setLoading({ data: true }));
        const rs = await getTickets(data, source);
        dispatch(setLoading({ data: false }));
        if (rs && rs.ok) {
            setGrid(rs.data);
            setOriginalGrid(rs.data);
        } else {
            alert(rs.msg);
            setGrid([]);
        }
    }

    // useEffect(() => {
    //     const CancelToken = axios.CancelToken;
    //     const source = CancelToken.source();

    //     const z = {
    //         status: +data.status,
    //         accounts: accounts
    //     };

    //     getdata(z, source);

    //     return () => {
    //         source.cancel('Operation canceled by the user.');
    //     }

    // }, [])

    useEffect(async () => {
        
        if (!valdiatePage('/complaintreport')) {
            history.push('/login');
        }

        const CancelToken = axios.CancelToken;
        const source = CancelToken.source();

        if (accounts.length > 0) {

            const subAccs = subaccounts.filter(e => e.accountNo.toUpperCase() === accounts[0].toUpperCase())

            setSubAccountsLocal(subAccs);

            const locs = await getMultipleSubAccountLocations({userId: userInfo.id, subAccountId: [subAccs[0].id]})
            const d = { ...data, Account: [accounts[0]], subAccountId: [subAccs[0].id]};

            console.log(locs);
            if (locs.length > 0) {
                d.LocationID = [+locs[0].value] 
                setLocations(locs);
                const z = {
                    status: +data.status,
                    accounts: [accounts[0]],
                    LocationID: [+locs[0].value] 
                };
        
                getdata(z, source);
            }
            setData(d);
        }
        return () => {
            source.cancel('Operation canceled by the user.');
        }
    }, [])


    const onSubmit = async () => {
        if (data.from && !data.to) {
            alert('Select To Date');
            return;
        }
        if (!data.from && data.to) {
            alert('Select From Date');
            return;
        }

        if (data.from && data.to) {
            if (Date.parse(data.from) > Date.parse(data.to)) {
                alert('Invalid Date');
                return;
            }
        }

        const z = {
            accounts: accounts,
            from: !data.from ? null : data.from,
            to: !data.to ? null : data.to,
            type: !data.type ? null : +data.type,
            cn: data.cn,
            orderRefNo: data.orderRefNo,
            status: +data.status,
            LocationID: data.LocationID
        }

        await getdata(z, null);
    }

    return userInfo && <section className="section">
        <div className="section-header">
            <h1>CXM Complaint Report</h1>
        </div>
        <div className="card" style={{ padding: 10 }}>
            <div className="row pb-2">
                <div className="col">
                    <label>Account</label>
                    <select className="form-select" multiple value={data.Account} onChange={async (e) => {
                        let value = Array.from(e.target.selectedOptions, option => option.value);
                        let d = { ...data, Account: value };
                        if (value && value.length > 0) {
                            const subAccs = subaccounts.filter(e => value.includes(e.accountNo));
                            setSubAccountsLocal(subAccs);
                            const locs = await getMultipleSubAccountLocations({userId: userInfo.id, subAccountId: [subAccs[0].id]})
                            d.subAccountId =  [subAccs[0].id];
                
                            if (locs.length > 0) {
                                d.LocationID = [+locs[0].value]
                                setLocations(locs);
                            } else {
                                setLocations([]);
                            }
                        } else {
                            setLocations([]);
                        }
                        setData(d);
                    }}>
                        {
                            accounts.map((x, index) => <option key={index} value={x}>{x}</option>)
                        }
                    </select>
                </div>

                <div className="col-lg">
                    <label>Sub Account</label>
                    <select className="form-select" value={data.subAccountId} multiple onChange={async (e) => {
                        const selectedOptions = Array.from(e.target.selectedOptions);

                        const accnos = selectedOptions
                            .map(option => option.getAttribute('data-accno'))
                            .filter(acc => acc && acc.trim() !== '');
                
                        const uniqueAccnos = Array.from(
                            new Map(accnos.map(acc => [acc.toLowerCase(), acc])).values()
                        );

                        const val = Array.from(new Set(
                            selectedOptions
                                .map(option => option.value)
                                .filter(v => v && !isNaN(v))
                                .map(v => parseInt(v))
                        ));


                        console.log("Filtered SubAccount IDs:", val);
                        console.log("Unique Account Nos (data-accno):", uniqueAccnos);

                        const d = { ...data, subAccountId: val, Account: uniqueAccnos };
                        if (val) {
                            //d.isCod = e.target[e.target.selectedIndex].getAttribute('data-iscod') === 'true';
                            const locs = await getMultipleSubAccountLocations({userId: userInfo.id, subAccountId: val})
                            console.log(locs);
                            if (locs && locs.length > 0) {
                                
                                d.LocationID = [+locs[0].value]
                                setLocations(locs);
                            } else {
                                setLocations([]);
                            }
                        } else {
                            setLocations([]);
                            //d.isCod = null;
                        }
                        setData({ ...d});
                    }}>
                        {
                            subAccountsLocal.map((x, index) => <option key={index} value={x.id} data-iscod={x.isCod} data-accno={x.accountNo}>{x.name}</option>)
                        }
                    </select>
                </div>

                <div className="col">
                    <label>Location</label>
                    <select className="form-select" multiple value={data.LocationID} onChange={async (e) => {
                        let val = Array.from(e.target.selectedOptions, option => +option.value);
                        setData({ ...data, LocationID: val });
                    }}>
                        {
                            locations.length > 0 && locations.map((x, index) => <option key={index} value={x.value}>{x.text}</option>)
                        }
                    </select>
                </div>
            </div>
            <div className="row">
                <div className="col-lg">
                    <label>From</label>
                    <input type="date" className="form-control" value={data.from} onChange={e => updateData('from', e.target.value)} />
                </div>
                <div className="col-lg">
                    <label>To</label>
                    <input type="date" className="form-control" value={data.to} onChange={e => updateData('to', e.target.value)} />
                </div>
                <div className="col-lg">
                    <label>Type</label>
                    <select className="form-select" value={data.type} onChange={e => updateData('type', e.target.value)}>
                        <option value="">Select Type</option>
                        <option value="1">Trace</option>
                        <option value="2">Complaint</option>
                    </select>
                </div>
                <div className="col-lg">
                    <label>Consignment #</label>
                    <input type="text" className="form-control" value={data.cn} maxLength={15} onInput={processInt} onChange={e => updateData('cn', e.target.value)} />
                </div>
                <div className="col-lg">
                    <label>Order Ref #</label>
                    <input type="text" className="form-control" value={data.orderRefNo} onInput={processStr} onChange={e => updateData('orderRefNo', e.target.value)} />
                </div>
                <div className="col-lg">
                    <label>Status</label>
                    <select className="form-select" value={data.status} onChange={e => updateData('status', e.target.value)}>
                        <option value="1">Open</option>
                        <option value="0">Close</option>
                    </select>
                </div>
            </div>
            <div className="row mt-2">
                <div className="col-lg" style={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <button type="button" className="btn btn-primary" onClick={onSubmit}>Submit</button>
                </div>
            </div>
            {
                originalGrid && originalGrid.length > 0 &&
                <Pagination
                    setGrid={setGrid}
                    searchObjInit={searchObjInit}
                    searchObject={searchObject}
                    originalGrid={originalGrid}
                    setPage={setPage}
                    setPageLimit={setPageLimit}
                    requestSort={requestSort}
                    sortConfig={sortConfig}
                    updateSearchData={updateSearchData}
                    sortedArray={sortedArray}
                    data={data}
                    dataCount={grid.length}
                    pageLimit={pageLimit}  
                    gridKeys={gridKeys}
                    page={page}
                    grid={
                        sortedArray && sortedArray.length > 0 && sortedArray.map((x, index) =>
                            <tr key={index}>
                                <td>{(index + 1)+(page*pageLimit)}</td>
                                <td>{x.TicketNo}</td>
                                <td>{x.CN}</td>
                                <td>{x.RequestNature}</td>
                                <td>{x.RequestType}</td>
                                <td>{x.Description}</td>
                                <td>{x.Status}</td>
                                <td>{x.LaunchBy}</td>
                                <td>{x.LaunchDate}</td>
                            </tr>
                        )
                    }
                />
            }
        </div>
    </section>
}

export default ComplaintReport;